import { Injectable } from '@angular/core';

import { NewsfeedResultsFacade } from '../state/newsfeed-results/newsfeed-results.facade';

@Injectable()
export class UserHistoryNewsfeedResolver {
  constructor(private facade: NewsfeedResultsFacade) {}
  resolve(): boolean {
    this.facade.setSource({ feed: 'HISTORY' });
    return true;
  }
}
